import {
  createInvitation,
  acceptInvitation,
  getUserByInvitation,
} from 'api/invitations'

import {
  CREATE_INVITATION_REQUEST,
  CREATE_INVITATION_SUCCESS,
  CREATE_INVITATION_FAILURE,
  ACCEPT_INVITATION_REQUEST,
  ACCEPT_INVITATION_SUCCESS,
  ACCEPT_INVITATION_FAILURE,
  GET_INVITATION_REQUEST,
  GET_INVITATION_SUCCESS,
  GET_INVITATION_FAILURE,
} from 'constants/action_types'

import { oauthTokenSelector } from 'selectors/app'
import { selectAccountSubdomainFromLocation } from 'selectors/location'

export function doCreateInvitation(invitation, responseFields) {
  return (dispatch, getState) => {
    dispatch({ type: CREATE_INVITATION_REQUEST, payload: { invitation } })
    const state = getState()
    const token = oauthTokenSelector(state)
    return createInvitation(token, invitation, responseFields)
      .then(response => {
        dispatch({
          type: CREATE_INVITATION_SUCCESS,
          payload: { response },
        })
        return response
      })
      .catch(error => {
        dispatch({ type: CREATE_INVITATION_FAILURE, payload: { error } })
        throw error
      })
  }
}

export function doAcceptInvitation(acceptInvitationInput, responseFields) {
  return dispatch => {
    dispatch({
      type: ACCEPT_INVITATION_REQUEST,
      payload: { acceptInvitationInput },
    })
    return acceptInvitation(null, acceptInvitationInput, responseFields)
      .then(response => {
        dispatch({
          type: ACCEPT_INVITATION_SUCCESS,
          payload: { response },
        })
        return response
      })
      .catch(error => {
        dispatch({
          type: ACCEPT_INVITATION_FAILURE,
          payload: { error: 'Unable to accept invitation, please try again' },
        })
        throw error
      })
  }
}

export function doGetUserByInvitation(invitationToken, responseFields) {
  return (dispatch, getState) => {
    const state = getState()
    const currentPageSubdomain = selectAccountSubdomainFromLocation(state)

    dispatch({
      type: GET_INVITATION_REQUEST,
      payload: { invitationToken },
    })

    return getUserByInvitation(null, invitationToken, responseFields)
      .then(response => {
        const payload = { response }
        if (currentPageSubdomain) {
          // this way dev envs still work as currentPageSubdomain will be null
          payload.currentPageSubdomain = currentPageSubdomain
        }

        dispatch({
          type: GET_INVITATION_SUCCESS,
          payload,
        })
        return response
      })
      .catch(error => {
        dispatch({
          type: GET_INVITATION_FAILURE,
          payload: { error: 'Unable to get invitation, please try again' },
        })
        throw error
      })
  }
}
